exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".unticket-box {\n  width: 1006px;\n  height: 448px;\n  background: #fff;\n  margin: 0 auto;\n  border-radius: 9px; }\n  .unticket-box .unticket-icon {\n    width: 204px;\n    height: 166px;\n    background: url(" + require("../../../images/unTicket.png") + ");\n    background-size: cover;\n    margin: 84px auto 0; }\n  .unticket-box p {\n    width: 100%;\n    text-align: center;\n    margin-top: 60px;\n    font-size: 14px;\n    color: #000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/ticket/unTicket/unTicket.scss
// module id = 651
// module chunks = 0